export enum ModalityCodesEnum {
  PR = 'PR', //presencial
  SP = 'SP', //semi-presencial,
  OL = 'OL', //online
  DI = 'DI', //distancia
  DU = 'DU', //Dual. Combina la educación en el aula con la formación práctica en el lugar de trabajo
}
